module.exports = __webpack_public_path__ + "img/GBM1_Treg.01931f0f.png";